import { SET_GENERAL_CONFIGURATIONS } from 'constants/MutationTypes'
import { getAllConfigurations } from '../../../httpServices/configurationGeneralHttpService'

const state = {
	configurations: []
}

const getters = {
	getConfigurations: state => state.configurations,

	getSellerReputationDays: state => {
		const sellerDays = state.configurations.find(
			parameter => parameter.name === 'SELLER.SELLER-REPUTATION.DAYS'
		)

		return sellerDays ? sellerDays.value : ''
	}
}

const actions = {
	loadGeneralConfigurations({ commit }) {
		return getAllConfigurations().then(response => {
			commit(SET_GENERAL_CONFIGURATIONS, response.data)
		})
	},

	setConfigurations({ commit }, configurations) {
		commit(SET_GENERAL_CONFIGURATIONS, configurations)
	}
}

const mutations = {
	[SET_GENERAL_CONFIGURATIONS](state, configurations) {
		state.configurations = configurations
	}
}

export default {
	state,
	getters,
	actions,
	mutations
}
